export const INTEGRATION_STEP = "integration";

export function withIntegrationStep(steps, enabled) {
  if (!enabled) return steps;
  const itemsIndex = steps.indexOf("items");
  if (itemsIndex === -1) return steps;
  return [...steps.slice(0, itemsIndex + 1), INTEGRATION_STEP, ...steps.slice(itemsIndex + 1)];
}

export function wizardProgress(steps, current) {
  const step = Math.max(steps.indexOf(current), 0);
  return { step, steps: steps.length };
}

export function nextAfterItems({ hasIntegration, hasCharges, chargeStep, fallbackStep }) {
  if (hasIntegration) return INTEGRATION_STEP;
  if (hasCharges) return chargeStep;
  return fallbackStep;
}

export function backFromCharges({ hasIntegration }) {
  return hasIntegration ? INTEGRATION_STEP : "items";
}
